import { defineMessages } from 'react-intl';
import enJson from './en.json';

const messages = defineMessages(
  Object.fromEntries(
    Object.entries(enJson).map(([id, defaultMessage]) => [
      id,
      { id, defaultMessage },
    ]),
  ),
);

export default messages;
